module.exports = __webpack_public_path__ + "static/media/nvidia_color.c8ba6cf2.png";